import { render, staticRenderFns } from "./buybuttonv2.vue?vue&type=template&id=0ac95458&scoped=true"
import script from "./buybuttonv2.vue?vue&type=script&lang=js"
export * from "./buybuttonv2.vue?vue&type=script&lang=js"
import style0 from "./buybuttonv2.vue?vue&type=style&index=0&id=0ac95458&lang=scss&scoped=true"
import style1 from "./buybuttonv2.vue?vue&type=style&index=1&id=0ac95458&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac95458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac95458')) {
      api.createRecord('0ac95458', component.options)
    } else {
      api.reload('0ac95458', component.options)
    }
    module.hot.accept("./buybuttonv2.vue?vue&type=template&id=0ac95458&scoped=true", function () {
      api.rerender('0ac95458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buybuttonv2.vue"
export default component.exports